import "core-js/modules/es.array.push.js";
import { defineComponent, defineAsyncComponent, ref, computed, watch, provide, onMounted } from 'vue';
import imageText from '@/components/imageText.vue';
import googleMaps from '@/components/googleMaps';
import accordion from '@/components/accordion';
import lowCode from '@/components/lowCode';
import subscription from '@/components/subscription';
import richText from '@/components/richText';
import imgSwipers from '@/components/imgSwipers';
import images from '@/components/images';
import videos from '@/components/videos';
import navigation from '@/components/navigation';
import goodsGrid from '@/components/goodsGrid';
import texts from '@/components/texts';
import hotMap from '@/components/hotMap';
import goodsScroll from '@/components/goodsScroll';
import mimo_replace from '@/components/home/mimo-replace';
import axios from "axios";
import { api } from "@/api/api";
import { useStore } from 'vuex';
import router from '@/router';
export default {
  name: 'welfare_m',
  components: {
    imageText,
    googleMaps,
    accordion,
    lowCode,
    subscription,
    richText,
    imgSwipers,
    images,
    videos,
    navigation,
    goodsGrid,
    texts,
    hotMap,
    goodsScroll,
    mimo_replace
  },
  setup() {
    const get_data = ref([]);
    const store = useStore(); // 该方法用于返回store 实例
    const Client = store.state.Client;
    const showPicturesList = ref([]);
    const event = ref([]);
    const loginShow = ref(false);
    const showState = ref(0); //0为注册，1为登录
    const userData = ref(false);
    // 当前选择的时间-年份
    const select_year = ref(0);
    // 当前选择的事件
    const select_event = ref(0);
    // 滚动辅助 判断是向上还是向下
    const auxiliary = ref(0);
    // 装修列表
    let url = api.baseUrl + api.webDecor + '?id=71';
    // 荣誉资质
    let showPictures = api.baseUrl + api.showPictures + '?type=honor';
    // 装修数据
    axios({
      url,
      method: "get"
    }).then(res => {
      let {
        data
      } = res;
      // console.log(data);
      if (data.data.background) {
        var d = document.getElementById("app");
        d.style.background = 'url(' + data.data.background + ')';
        if (data.data.backgroundFit == 'fill') {}
        d.style.backgroundSize = data.data.backgroundFit == 'fill' ? '100% 100%' : 'auto 100%';
        d.style.backgroundPosition = 'center', d.style.backgroundRepeat = 'no-repeat';
      }
      get_data.value = JSON.parse(data.data.editConfig);
      console.log(get_data.value);
    });
    const get_data_list = ref([]);
    // 获取信息
    const get_dataList = () => {
      axios({
        url: api.baseUrl + api.benefit,
        method: 'get'
      }).then(res => {
        // console.log(res);
        get_data_list.value = res.data.rows;
        console.log(get_data_list.value);
      });
    };
    const details = (e, name) => {
      if (name.indexOf("肌功能") !== -1) {
        router.push({
          name: localStorage.getItem('userData') ? 'member_welfare_m' : 'welfare_details',
          params: {
            id: e
          }
        });
      } else {
        router.push({
          name: 'welfare_details_brief',
          params: {
            id: e
          }
        });
      }
    };
    // 事件点击切换
    const event_click = (index, ind) => {
      console.log(index);
      console.log(ind);
      select_year.value = index;
      select_event.value = ind;
    };
    const show = () => {
      store.commit('serviceShow', true);
    };
    //了解更多
    const learnMore = () => {
      loginShow.value = true;
    };
    const modifyShowState = e => {
      loginShow.value = false;
    };
    const getUserData = () => {
      console.log(localStorage.getItem('userData'));
      if (localStorage.getItem('userData')) {
        userData.value = JSON.parse(localStorage.getItem('userData'));
      }
    };
    const gotoWelfareD = () => {
      router.push({
        name: 'welfare_details',
        params: {
          id: 2
        }
      });
    };
    const gotoWelfareDB = () => {
      router.push({
        name: 'welfare_details_brief',
        params: {
          id: 3
        }
      });
    };
    const openFile = type => {};
    get_dataList();
    return {
      get_data,
      Client,
      showPicturesList,
      event,
      select_year,
      select_event,
      // scrollHandler
      event_click,
      show,
      modifyShowState,
      getUserData,
      userData,
      learnMore,
      loginShow,
      showState,
      gotoWelfareD,
      gotoWelfareDB,
      openFile,
      get_dataList,
      get_data_list,
      details
    };
  }
};